import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type BrokenContainerReportFieldsFragment = { __typename?: 'BrokenContainerReport', id: string, store_id: string, store_name?: string | null, context: Types.BrokenContainerReportContext, merchant_order_id?: string | null, merchant_order_delivery_note_id?: number | null, comment?: string | null, created_at: string, created_by?: string | null, container_total: number, lines: Array<{ __typename?: 'BrokenContainerLine', id: string, container_type_id: number, container_type_name?: string | null, image_url?: string | null, amount: number, part: Types.BrokenContainerPart, active?: boolean | null, cleared_at?: string | null, cleared_by?: string | null, container?: { __typename?: 'ReturnOrderContainer', id: string, name?: string | null, short_id?: string | null } | null, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> };

export const BrokenContainerReportFieldsFragmentDoc = gql`
    fragment BrokenContainerReportFields on BrokenContainerReport {
  id
  store_id
  store_name
  context
  merchant_order_id
  merchant_order_delivery_note_id
  comment
  created_at
  created_by
  container_total
  lines {
    id
    container_type_id
    container_type_name
    image_url
    amount
    part
    container {
      id
      name
      short_id
    }
    active
    cleared_at
    cleared_by
    photos {
      id
      thumbnail_url: url
      url_full_size
      created_at
    }
  }
  photos {
    id
    thumbnail_url: url
    url_full_size
    created_at
  }
}
    `;